import { Form } from "antd";
// import { defaultDateFormat, defaultMonthFormat } from "../configs";
import dayjsGenerateConfig from "rc-picker/lib/generate/dayjs";
import generatePicker from "antd/es/date-picker/generatePicker";
import dayjs from "dayjs";

import locale from "antd/es/date-picker/locale/th_TH";
const defaultDateFormat = "DD-MM-BBBB";
const defaultDatePickerFormat = "DD-MM-YYYY";
const defaultMonthFormat = "BBBB-MM";
const dateTimeFormatBB = "BBBB-MM-DD hh:mm:ss";

const config = {
  ...dayjsGenerateConfig,
  setYear: (date: any, year: any) => {
    return date.year(year - 543);
  },
  getYear: (date: any) => Number(date.format("BBBB")),
};
const DatePicker = generatePicker(config);
const { RangePicker } = DatePicker;

const datePickerTh = {
  ...locale,
  lang: {
    ...locale.lang,
    yearFormat: "BBBB",
    dateFormat: "M/D/BBBB",
    dateTimeFormat: "M/D/BBBB HH:mm:ss",
  },
  dateFormat: "BBBB-MM-DD",
  dateTimeFormat: "BBBB-MM-DD HH:mm:ss",
  weekFormat: "BBBB-wo",
  monthFormat: "BBBB-MM",
};

export const BuddhistRangePicker = () => {
  return (
    <Form.Item name="dates">
      <DatePicker locale={datePickerTh} format={defaultDateFormat} style={{ width: "100%" }} />
    </Form.Item>
  );
};

export const BuddhistRangePickerDisabled = () => {
  return (
    <Form.Item name="dates">
      <DatePicker locale={datePickerTh} format={defaultDateFormat} style={{ width: "100%" }} disabled />
    </Form.Item>
  );
};

export const BuddhistRangePickerDate = () => {
  return (
    <Form.Item rules={[{ required: true }]} label="วันที่ติดตามหนี้ :" name="dates">
      <RangePicker style={{ width: "100%" }} locale={datePickerTh} format={[defaultDateFormat, defaultDateFormat]} />
    </Form.Item>
  );
};

export const BuddhistRangePickerDateSenddate = () => {
  return (
    <Form.Item rules={[{ required: true }]} label="วันที่ส่งงาน :" name="send_dates">
      <RangePicker style={{ width: "100%" }} locale={datePickerTh} format={[defaultDateFormat, defaultDateFormat]} />
    </Form.Item>
  );
};

export const BuddhistDatePicker = () => {
  return (
    <Form.Item rules={[{ required: true }]} label="เดือนที่ส่งงาน :" name="month">
      <DatePicker locale={datePickerTh} picker="month" format={[defaultMonthFormat]} />
    </Form.Item>
  );
};

export const BuddhistDatePickers = () => {
  return (
    <Form.Item rules={[{ required: true }]} label="วันที่ของข้อมูล :" name="dates">
      <DatePicker locale={datePickerTh} format={[defaultDateFormat]} />
    </Form.Item>
  );
};

export const BuddhistRangePickerDates = () => {
  return (
    <Form.Item label="วันที่ได้รับงาน" name="dates">
      <RangePicker locale={datePickerTh} style={{ width: "-webkit-fill-available" }} format={[defaultDateFormat, defaultDateFormat]} />
    </Form.Item>
  );
};

export const BuddistDateRangePicker = () => {
  return (
    <Form.Item rules={[{ required: true }]} label="เดือนที่ส่งงาน :" name="dates">
      <RangePicker
        locale={datePickerTh}
        picker="month"
        format={[defaultMonthFormat, defaultMonthFormat]}
        disabledDate={(current) => {
          return dayjs().add(-12, "month") >= current || dayjs().add(0, "month") <= current;
        }}
      />
    </Form.Item>
  );
};

export const BuddistDatePickerDashboardPerformanceOutStanding = () => {
  return (
    <Form.Item rules={[{ required: true }]} label="วันที่ส่งงาน :" name="dates">
      <RangePicker locale={datePickerTh} picker="month" format={[defaultMonthFormat, defaultMonthFormat]} />
    </Form.Item>
  );
};

export const BuddistDebtCollectionAssignmentFiltering = () => {
  return (
    <Form.Item rules={[{ required: true }]} label="วันที่เริ่มแจกงาน :" name="dates">
      <RangePicker locale={datePickerTh} style={{ width: "-webkit-fill-available" }} format={[defaultDateFormat, defaultDateFormat]} />
    </Form.Item>
  );
};

export const BuddistDatePickerUntrackedDebtReport = () => {
  return (
    <Form.Item rules={[{ required: true }]} label="วันที่ได้รับงาน :" name="dates">
      <RangePicker locale={datePickerTh} format={[defaultDateFormat, defaultDateFormat]} style={{ width: "100%" }} />
    </Form.Item>
  );
};

export const toBuddhistDate = (label: string) => {
  const d = String(label).split("/");
  const djs = dayjs();
  const [month, year] = d.length > 1 ? d : [String(djs.month() + 1), String(djs.year())];
  const gregorianDate = new Date(`${month}/01/${year}`);
  const buddhistYear = gregorianDate.getFullYear() + 543;
  const buddhistMonth = gregorianDate.getMonth() + 1;
  return { year: buddhistYear, month: buddhistMonth };
};
